import React from 'react';

import { useRecuperarBibliografiasQuery } from 'View/Service/Default/Bibliografias';

interface Props {
  unidadeDeAprendizagemId: number;
}

const Bibliografias = ({
  unidadeDeAprendizagemId,
}: Props): React.ReactElement => {
  const { data: { bibliografias } = {} } = useRecuperarBibliografiasQuery({
    options: { unidade_de_aprendizagem_id: unidadeDeAprendizagemId },
    sort: 'titulo',
  });

  return (
    <React.Fragment>
      <p className="fs-2 fw-bold">Bibliografia</p>
      <p>
        Aqui você encontrará toda a bibliografia do conteúdo utilizado nessa
        aula. Utilize para aprimorar seus conhecimentos sobre o assunto!
      </p>
      {bibliografias?.map((bibliografia, chave) => (
        <p
          key={`${bibliografia.id}-${bibliografia.modificado}`}
          className={`fs-5 pt-3 cursor-pointer ${chave ? 'border-top' : ''} ${bibliografia.url ? 'text-primary' : ''}`}
          onClick={() => bibliografia.url ? window.open(bibliografia.url) : null}
        >
          {bibliografia.titulo}
          <small className="text-muted d-block fs-6">
            Atualizado em {bibliografia.modificado.data().toLocaleString()}
          </small>
        </p>
      ))}
    </React.Fragment>
  );
};

export default Bibliografias;
